import styled from 'styled-components';

interface ImageStProps {
  maxWidth?: number;
}

export const ImageSt = styled.img<ImageStProps>`
  max-height: 100%;
`;
